exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_wks-ext.js
// module id = Sa8a
// module chunks = 0